import { isDeakinEmail } from '@/auth/passwordReset';
import BaseModel from './BaseModel';

export default class Researcher extends BaseModel {
  constructor(data = {}) {
    super(Researcher, data);
    this.id = data.id;
    this.userId = data.userId;
    this.name = data.name;
    this.email = data.email;
    this.isSuperAdmin = data.isSuperAdmin;
    this.canCreateReviews = data.canCreateReviews;
    this.status = data.status || 'ACTIVE';
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  firstName() {
    return this.name.split(' ')[0];
  }

  isActive() {
    return this.status === 'ACTIVE';
  }

  isDeactivated() {
    return this.status === 'DEACTIVATED';
  }

  isDeakinUser() {
    return isDeakinEmail(this.email);
  }
}
